import { Badge, Button, Card, Checkbox, Empty, Row, Space, Table } from 'antd';
import * as React from 'react';
import { CustomerServiceQueries } from '../../queries/customer-service-queries';
import { GabiiFullFeedback } from '../../models/gabii-full-feedback-interface';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import moment from 'moment';
import { SortOrder } from 'antd/lib/table/interface';

type Filter = {
  text: string;
  value: boolean;
};

function GabiiFeedbackPage() {
  const [showDemoCompanies, setShowDemoCompanies] = React.useState<boolean>(false);
  const gabiiFeedbackQuery = CustomerServiceQueries.useGabiiFeedback();

  const boolFilters: Filter[] = [
    {
      value: true,
      text: 'Positive',
    },
    {
      value: false,
      text: 'Negative',
    },
  ];

  const columns = [
    {
      title: 'User',
      dataIndex: 'userName',
      key: 'userName',
      sorter: {
        compare: (a: { userName: string; }, b: { userName: string; }) => a.userName.localeCompare(b.userName)
      },
      render: (userName: string, feedback: GabiiFullFeedback) => {
        return <Link to={`/admin/user/${feedback.userId}`}>{userName}</Link>
      },
    },
    {
      title: 'User Id',
      dataIndex: 'userId',
      key: 'userId',
      sorter: {
        compare: (a: { userId: number; }, b: { userId: number; }) => (a.userId - b.userId)
      },
    },
    {
      title: 'Company',
      dataIndex: 'companyName',
      key: 'name',
      sorter: {
        compare: (a: { companyName: string; }, b: { companyName: string; }) => a.companyName.localeCompare(b.companyName)
      },
      render: (companyName: string, feedback: GabiiFullFeedback) => {
        return <Link to={`/admin/company/${feedback.companyId}`}>{companyName}</Link>
      },
    },
    {
      title: 'Company Id',
      dataIndex: 'companyId',
      key: 'companyId',
      sorter: {
        compare: (a: { companyId: number; }, b: { companyId: number; }) => (a.companyId - b.companyId)
      },
    },
    {
      title: 'Is Positive',
      dataIndex: 'positiveFeedback',
      key: 'positiveFeedback',
      render: (positiveFeedback: boolean) => {
        return positiveFeedback ? (<FontAwesomeIcon className='primary-text' icon={faCheck as IconProp} />) : (<FontAwesomeIcon className='red-icon' icon={faXmark as IconProp} />)
      },
      filters: boolFilters,
      onFilter: (value: boolean | any, record: GabiiFullFeedback) => {
        return value === record.positiveFeedback;
      },
    },
    {
      title: 'User Feedback',
      dataIndex: 'description',
      key: 'description',
    },
    /*{
      title: 'Commented Line',
      dataIndex: 'chatEntryMessage',
      key: 'chatEntryMessage',
    },
    {
      title: 'Previous User Line',
      dataIndex: 'previousUserMessage',
      key: 'previousUserMessage',
    },*/
    {
      title: 'Date (UTC)',
      dataIndex: 'reportDate',
      key: 'reportDate',
      sorter: {
        compare: (a: { reportDate: string; }, b: { reportDate: string; }) => new Date(a.reportDate).getTime() - new Date(b.reportDate).getTime()
      },
      render: (reportDate: string) => {
        return moment(reportDate).format("MM/DD/yyyy h:mm:ss a");
      },
      defaultSortOrder: 'descend' as SortOrder,
    },
  ]

  return (
    <Card
      loading={gabiiFeedbackQuery.isLoading}
      title="Gabii Feedback"
    >
      <Row justify="end" style={{marginBottom: 20}}>
        <Checkbox checked={showDemoCompanies} onChange={(v) => setShowDemoCompanies(v.target.checked)}>Show Demo Companies</Checkbox>
      </Row>
      <Table
        columns={columns}
        dataSource={gabiiFeedbackQuery?.data?.filter(x => showDemoCompanies || !x.demoCompany)}
        size='middle'
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={`No users found`}
            />
          ),
        }}
      />
    </Card>
  );
}

export default GabiiFeedbackPage;
